import React from "react";
import { ShieldCheck, Download, FileCheck2, FileX2 } from "lucide-react";
import { DOCS, itDate, downloadFile } from "@/lib/pa";

export function PaKitBox({ provider }) {
  const c = provider.compliance;
  if (!c) return null;
  const any = Object.keys(c.docs || {}).length > 0;
  return (
    <div className="card-premium p-5 space-y-4" data-testid="pa-kit-box">
      <div className="flex items-center justify-between gap-2">
        <h3 className="font-display text-lg font-bold flex items-center gap-2"><ShieldCheck className="w-5 h-5 text-gold"/>Kit Trasparenza PA</h3>
        <span data-testid="pa-kit-count" className={c.kitComplete ? "chip-gold" : "chip-navy"}>{c.kitCount}/{c.kitTotal}</span>
      </div>
      <ul className="space-y-2 text-sm">
        {DOCS.map((d) => {
          const r = c.docs?.[d.key];
          const ok = r && !r.expired;
          return (
            <li key={d.key} className="flex items-start gap-2" data-testid={`pa-kit-doc-${d.key}`}>
              {ok ? <FileCheck2 className="w-4 h-4 text-emerald-600 mt-0.5 shrink-0"/> : <FileX2 className="w-4 h-4 text-slate-400 mt-0.5 shrink-0"/>}
              <span className="flex-1">{d.label}
                <span className="block text-xs text-slate-500">{r ? (r.expired ? `Scaduto il ${itDate(r.validUntil)}` : r.validUntil ? `Valido fino al ${itDate(r.validUntil)}` : `Caricato il ${itDate(r.uploadedAt)}`) : "Non disponibile"}</span>
              </span>
              {r && <button type="button" data-testid={`pa-kit-download-${d.key}`} onClick={() => downloadFile(`/compliance/${provider.id}/${d.key}`, `${d.key}.pdf`)} className="text-gold hover:text-navy" aria-label={`Scarica ${d.label}`}><Download className="w-4 h-4"/></button>}
            </li>
          );
        })}
      </ul>
      <button type="button" data-testid="pa-kit-download-all" disabled={!any} onClick={() => downloadFile(`/compliance/${provider.id}/kit`, "Kit-Trasparenza-PA.zip")}
        className="w-full btn-pill-gold justify-center text-sm disabled:opacity-40 disabled:cursor-not-allowed"><Download className="w-4 h-4"/>Scarica Kit completo (ZIP)</button>
      <p className="text-[11px] text-slate-500 leading-snug">Documenti caricati dall'operatore sotto la propria esclusiva responsabilità (artt. 46-47 D.P.R. 445/2000). Il portale non ne verifica il contenuto.</p>
    </div>
  );
}
